import { IntentLandingScreen } from "@/screens/prequal/IntentLandingScreen"
import { EnsureLaunchDarklyInitialized } from "@/components/EnsureLaunchDarklyInitialized"

export default function LandingPage() {
  return (
    <EnsureLaunchDarklyInitialized>
      <IntentLandingScreen />
    </EnsureLaunchDarklyInitialized>
  )
}
